import {AppThemeConfigurator} from "@/configuration/appThemeConfigurator";
import {IAppConfig} from "@/interfaces/appConfig.interface";
import defaultAppConfig from "@/configuration/defaultAppConfig";
import * as _ from 'lodash';

export class AppConfigurator {

    private static instance: AppConfigurator;

    private appConfig: IAppConfig;

    private appThemeConfigurator: AppThemeConfigurator;

    private constructor() {
        this.appConfig = _.cloneDeep(defaultAppConfig);
        this.appThemeConfigurator = new AppThemeConfigurator();
    }

    public static getInstance() {
        if (!this.instance) {
            this.instance = new AppConfigurator();
        }
        return this.instance;
    }

    public assignAppConfig(appConfig: IAppConfig) {
        this.appConfig = _.cloneDeep(defaultAppConfig);
        this.appConfig = _.mergeWith(this.appConfig, appConfig, (a, b) =>
            _.isArray(b) ? b : undefined // Replace arrays instead of merging them. E.g. task list should be overwritten, not merged.
        );
    }

    public getAppConfig() {
        return this.appConfig;
    }

    public applyConfiguration() {
        this.appThemeConfigurator.applyTheme(this.appConfig);
    }

}